import * as TYPES from './_store/types';

export async function asyncData(store) {
    
    const { ids } = this;
    return Promise.all([store[TYPES.FETCH_NBR_LIST]({ ids })]);
}
